import React from "react";
import { createRoot } from "react-dom/client";
import { Nav2022App } from "./App";

// temp suppressing intl errors --------------
// eslint-disable-next-line
const consoleError = console.error.bind(console);
// eslint-disable-next-line
console.error = (message, ...args) => {
  if (message.code === "MISSING_TRANSLATION") {
    return;
  }
  consoleError(message, ...args);
};
// ---------------------------------------------

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Nav2022App />);
